<div class="flex flex-justify-between flex-middle">

    <!-- title -->
    <p class="s1 col-1">{{ review?.data?.title }}</p>

    <!-- close -->
    <button role="button"
            [style.width.px]="16"
            aria-label="Close"
            (click)="close()">
        <i class="icon-close"
           aria-hidden="true"></i>
    </button>
</div>

<!-- rating -->
<rating *ngIf="review?.data?.rating"
        class="block m-t"
        [value]="review.data.rating / 20"></rating>

<!-- review copy -->
<div class="p2 col-1 m-t-5">{{ review?.data?.content }}</div>

<!-- author and date -->
<p class="p2 col-11 m-t-3">
    {{ review?.data?.author }} {{ 'on' | translate }} {{ review?.data?.date | date: 'dd' | ordinal }}
    {{ review?.data?.date | date: 'MMMM yyyy' }}
</p>

<!-- close -->
<button class="button-inline m-t-3"
        role="button"
        aria-label="Close"
        (click)="close()">
    <span>{{ 'Close' | translate }}</span>
</button>
